import { useMutation } from '@tanstack/react-query';

import apiHelper from '@/apiHelper';
import { UnlockNookRequest } from '@/types/nook';

const useUnlockNookMutation = () => {
  return useMutation({
    mutationFn: async (data: UnlockNookRequest) => {
      const response = await apiHelper.post('/api/nook/unlock', data);
      return response.data;
    },
  });
};

export default useUnlockNookMutation;
